import { supabase } from "@/integrations/supabase/client";
import { logError } from "@/lib/error-utils";

/**
 * Send webhook via server-side function for security
 * This prevents client-side manipulation of webhook URLs
 */
export const sendWebhook = async (data: any) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      console.error('Cannot send webhook: not authenticated');
      return;
    }

    const { error } = await supabase.functions.invoke('trigger-webhook', {
      body: data,
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    });

    if (error) {
      // Fire-and-forget — capture for support, but the caller isn't blocked.
      logError(error, 'trigger-webhook');
    }
  } catch (error) {
    logError(error, 'trigger-webhook');
  }
};
